interface TabHeaderProps {
    setActiveNav: (newStatus: number) => void;
    currentActiveNav: number;
    activeNavValue: number;
    text: string;
}

const TabHeader = ({
    setActiveNav,
    currentActiveNav,
    text,
    activeNavValue,
}: TabHeaderProps) => {
    return (
        <li className='nav-item' onClick={() => setActiveNav(activeNavValue)}>
            <a
                href='#'
                type='button'
                className={`text-body nav-link text-primary2 ${
                    currentActiveNav === activeNavValue && 'tab_profile-title'
                }`}
            >
                {text}
            </a>
        </li>
    );
};

export default TabHeader;
